import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../seguranca/auth.service';
import { Router } from '@angular/router';
import { ToastyService } from 'ng2-toasty';

@Component({
  standalone: false,
  selector: 'app-left-side',
  templateUrl: './left-side.component.html',
  styleUrls: ['./left-side.component.css']
})
export class LeftSideComponent implements OnInit {

  constructor(
    public auth: AuthService,
    private router: Router,
    private toasty: ToastyService
  ) {}

  ngOnInit() {
  }

  gotoHabilitacao(param) {
    this.router.navigate(["/habilitacao/visualizar"]);
    sessionStorage.setItem('tipoHabilitacao', param)
  }


}
